/**
 * SOLIVA — Hebrew labels for the Vouch review widget.
 *
 * Vouch renders its own markup client-side and, at the time of writing, exposes
 * no storefront text settings. Buttons and labels are translated in soliva.css;
 * the two things CSS cannot reach are handled here:
 *   1. <option> text inside the sort dropdown
 *   2. the "N Reviews" count, where the number must be preserved
 *
 * Everything is a no-op when the widget is absent, and unknown strings are left
 * untouched, so a Vouch update can only ever cost us the translation — never
 * the widget itself.
 */
(() => {
  const SORT_LABELS = {
    'Most Recent': 'החדשות ביותר',
    'Highest Rating': 'הדירוג הגבוה',
    'Lowest Rating': 'הדירוג הנמוך',
    'Most Helpful': 'המועילות ביותר',
  };

  const translateSortOptions = (root) => {
    root.querySelectorAll('select.review-sort-select option, #review-sort option').forEach((option) => {
      const hebrew = SORT_LABELS[option.textContent.trim()];
      if (hebrew) option.textContent = hebrew;
    });
  };

  // "20 Reviews" / "1 Review" → "20 ביקורות" — keep the number, swap the word.
  const translateCount = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const value = node.nodeValue;
      if (!value || value.indexOf('Review') === -1) continue;
      const next = value
        .replace(/(\d[\d,.]*)\s*Reviews\b/g, '$1 ביקורות')
        .replace(/(\d[\d,.]*)\s*Review\b/g, '$1 ביקורות')
        .replace(/^\s*Reviews\s*$/, 'ביקורות');
      if (next !== value) node.nodeValue = next;
    }
  };

  const apply = () => {
    const widget = document.querySelector('.review-widget');
    if (!widget) return false;
    translateSortOptions(widget);
    translateCount(widget);
    return true;
  };

  const start = () => {
    apply();
    // The widget hydrates asynchronously and re-renders on sort / load-more,
    // so watch it rather than guessing a delay.
    const host = document.querySelector('.shopify-app-block') || document.body;
    const observer = new MutationObserver(() => apply());
    observer.observe(host, { childList: true, subtree: true });
    // Stop observing once the page has settled; the widget is stable by then.
    setTimeout(() => observer.disconnect(), 20000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
